import { Form, Formik } from 'formik';

import { MenteeToMentorFormContent } from 'hb-react/frontoffice/apps/Mentoring/components/MenteeToMentorFormContent';
import { useUpdateRelationshipRequest } from 'hb-react/frontoffice/apps/Mentoring/hooks/useMutateRelationship';
import type {
  Program,
  RelationshipWithUser,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { LockScreen } from 'hb-react/shared/components/LockScreen';

interface ReapplyMenteeToMentorFormProps {
  program: Program;
  mentorName: string;
  relationshipWithCurrentUser: RelationshipWithUser;
  onSuccess: () => void;
}

export const ReapplyMenteeToMentorForm = ({
  program,
  mentorName,
  relationshipWithCurrentUser,
  onSuccess,
}: ReapplyMenteeToMentorFormProps) => {
  const { isPending, mutateAsync } = useUpdateRelationshipRequest({
    program,
    relationshipId: relationshipWithCurrentUser.id,
    onSuccess,
  });

  const onSubmit = async (values: { message: string }) => {
    try {
      await mutateAsync({
        application_message: values.message,
        status: 'pending',
      });
      // eslint-disable-next-line no-empty
    } catch {}
  };

  return (
    <Formik initialValues={{ message: '' }} onSubmit={onSubmit}>
      {() => (
        <Form>
          {isPending && <LockScreen />}
          <MenteeToMentorFormContent
            program={program}
            mentorName={mentorName}
            dataTestId="mentee-reapply-form"
          />
        </Form>
      )}
    </Formik>
  );
};
